<!-- ===============================
     COMPONENTE: LoadingOverlay.vue
================================ -->
<template>
  <transition name="fade">
    <div v-if="visible" class="overlay-processamento">
      <div class="overlay-conteudo">
        <div class="spinner"></div>

        <h2>{{ title }}</h2>
        <p class="mensagem">{{ message }}</p>

        <div v-if="showProgress" class="barra">
          <div class="preenchimento" :style="{ width: progress + '%' }"></div>
        </div>

        <p v-if="hint" class="dica-final">{{ hint }}</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
defineProps({
  visible: Boolean, // controla exibição
  progress: { type: Number, default: 0 },
  title: { type: String, default: "Processando..." },
  message: { type: String, default: "Aguarde, estamos analisando os dados." },
  hint: { type: String, default: "Isso pode levar alguns segundos." },
  showProgress: { type: Boolean, default: true },
});
</script>

<style scoped>
.overlay-processamento {
  position: fixed;
  inset: 0;
  background: rgba(255, 253, 246, 0.96); /* fundo palha translúcido */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 9999;
  backdrop-filter: blur(3px);
}

.overlay-conteudo {
  text-align: center;
  color: #0a1a3a;
  background: #ffffff;
  padding: 36px 40px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid #ffe8b3;
  max-width: 420px;
  width: 90%;
  animation: slideUp 0.5s ease;
}

.overlay-conteudo h2 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #0a1a3a;
  margin-bottom: 10px;
}

.overlay-conteudo .mensagem {
  color: #444;
  font-size: 0.95rem;
  margin-bottom: 20px;
}

.barra {
  width: 100%;
  height: 10px;
  background: #f8f8f8;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #ffeab5;
}
.preenchimento {
  height: 100%;
  background: linear-gradient(90deg, #ff2e79, #ffc300);
  transition: width 0.5s ease;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 5px solid #ffebc2;
  border-top-color: #ff2e79;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

.dica-final {
  font-size: 0.9rem;
  color: #888;
  margin-top: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ====== ANIMAÇÕES ====== */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes slideUp {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
